export const NEXT_ADAPTER_DEPS = [
  '@hookform/resolvers',
  '@tanstack/react-query',
  '@tanstack/react-table',
  '@tanstack/react-virtual',
  'better-auth',
  'class-variance-authority',
  'clsx',
  'date-fns',
  'drizzle-orm',
  'fuse.js',
  'geist',
  'kysely@0.28.17',
  'lucide-react@1.7.0',
  'nuqs',
  'postgres',
  'react-dropzone',
  'react-hook-form',
  'shadcn',
  'sonner',
  'tailwind-merge',
  'tw-animate-css',
  'usehooks-ts',
  'zod'
]

export const NEXT_ADAPTER_DEV_DEPS = ['drizzle-kit', 'pg', 'tsx']
